import { createElement } from 'react';
import { Input } from '@alifd/next';
import './index.scss';
import dayjs from 'dayjs';
const ColorfulInput = function ColorfulInput({ color, style = {}, ...otherProps }) {
    const _style = style || {};
    if (color) {
        _style.backgroundColor = color;
    }
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    return (createElement("div", null,
        createElement("h1", null, "Colorful Input"),
        createElement("h1", null, dayjs().format('YYYY-MM-DD HH:mm:ss')),
        createElement(Input, Object.assign({}, _otherProps))));
};
export default ColorfulInput;
